export default "__VITE_ASSET__125fdc30__"